module.exports = __webpack_public_path__ + "static/media/openEdX-development-icon.3a547829.svg";